import Backbone from 'backbone';

const noop = () => {};
const fakeModel = { get: noop, toJSON: noop };

export const isBackboneModel = obj => (obj instanceof Backbone.Model);

export const getModelOrSafeMock = (obj) => {
    if (isBackboneModel(obj)) {
        return obj;
    }

    return fakeModel;
};
